export enum PlatformsSlugs {
  Advanced = 'advanced',
  VMWare = 'vmware',
  Evolution = 'evolution',
}
